module.exports = __webpack_public_path__ + "static/grafika15-feb98f643e5e6fd304f05fd86244c555.png";